import React, { useState, useCallback, useMemo, memo, useEffect } from "react";
import {
  Input,
  Button,
  Card,
  Spin,
  message,
  Modal,
  Select,
  Avatar,
  Empty,
  Tag,
  Space,
  Divider,
  Row,
  Col,
  Tabs,
  Pagination,
  Form,
  Upload,
  List,
  Tooltip,
} from "antd";
import {
  SearchOutlined,
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  MedicineBoxOutlined,
  CheckCircleOutlined,
  CalendarOutlined,
  TeamOutlined,
  PlusOutlined,
  EditOutlined,
  SaveOutlined,
  UserAddOutlined,
  UploadOutlined,
  ClockCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import drEasyApi from "../../../Api/Customapi";
import PageTitle from "../../Ui/PageTitle";
import { getImg } from "../../../Api/getImg";
import { BsHospital } from "react-icons/bs";
import { IoIosPaper } from "react-icons/io";
import { FaUserMd } from "react-icons/fa";
import { uploadImage } from "../../../Api/uploadImg";
import DoctorPerformance from "./DoctorPerformance";
import ImageUploader from "../../Ui/ImageUploader";
import { useCheckDoctorVacation } from "../../../hooks/Usevacations";
import dayjs from "dayjs";
const SpecialistCard = memo(({ item, index, isMobile, onClick }) => {
  const joinDate = new Date(item.joinDate).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  const { data: vacationData } = useCheckDoctorVacation(item.doctorId);
  const role=localStorage.getItem("role");

  const clinicCount = item.clinics ? item.clinics.length : 0;
  const vacationLabel =
    vacationData?.isOnVacation &&
    vacationData?.startDate &&
    vacationData?.endDate
      ? `On vacation: ${dayjs(vacationData.startDate).format("MMM D")} – ${dayjs(vacationData.endDate).format("MMM D, YYYY")}`
      : "On Vacation";

  return (
    <Card
      className="overflow-hidden shadow-md border border-[#298d9f73] hover:shadow-xl transition-all rounded-lg cursor-pointer"
      style={{
        animationDelay: `${index * 100}ms`,
        animation: "fadeInUp 0.6s ease-out forwards",
      }}
    >
      <Card.Meta />
      <div className={`flex items-center mb-4 gap-2 ${isMobile ? "flex-wrap" : ""}`}>
        <span
          className={`border rounded-full flex justify-center items-center ${
            vacationData?.isOnVacation
              ? "border-orange-400 bg-orange-400"
              : "border-primary"
          }`}
        >
          <Avatar
            src={
              getImg(item.photoId) ||
              "https://res.cloudinary.com/dk2uh7sho/image/upload/v1750278754/default-img_tbc2pe.jpg"
            }
            size={isMobile ? 40 : 70}
            className="shadow-lg "
          >
            {!getImg(item.photoId) && item.name?.charAt(0)?.toUpperCase()}
          </Avatar>
        </span>
        <div className="flex items-center gap-2 text-lg font-semibold text-[#298d9f] hover:text-primary_hover transition-colors">
          <span>
            {item.name}
            {item.specialization && (
              <p className="text-xs font-normal text-gray-600">
                {item.specialization}
              </p>
            )}
          </span>
        </div>
      </div>
      {item.description && (
        <p className="text-sm text-gray-600 mt-2 line-clamp-3">
          {item.description}
        </p>
      )}

      <div className="mt-4 space-y-3">
        <div className="flex items-center gap-2 text-xs text-gray-500">
          <CalendarOutlined />
          <span>Joined: {joinDate}</span>
        </div>

        <div className="flex items-center gap-2 text-xs text-gray-500">
          <MailOutlined />
          <span>{item.email}</span>
        </div>

        {vacationData?.isOnVacation ? (
          <Tooltip title={vacationLabel}>
            <Tag
              color="orange"
              icon={<ClockCircleOutlined />}
              className="rounded-full cursor-default"
            >
              On Vacation
            </Tag>
          </Tooltip>
        ) : (
          <Tag
            color="green"
            icon={<CheckCircleOutlined />}
            className="rounded-full"
          >
            Active
          </Tag>
        )}
        {clinicCount > 0 && (
          <Tag color="green" className="mt-2">
            {clinicCount} Clinic{clinicCount > 1 ? "s" : ""}
          </Tag>
        )}
        {role!=3 || role!=7&&
         <Button
            type=""
            icon={<EyeOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              onClick(item);
            }}
            className="bg-primary hover:bg-primary_hover text-white border-0 rounded-lg font-medium hover:shadow-lg"
            size={isMobile ? 'small' : 'middle'}
          >
            View Performance
          </Button>}
      </div>
    </Card>
  );
});
export default SpecialistCard;
